import React from 'react';
import { Title,Body } from '@vds3/typography'
import { MarginSpacerM, MarginSpacerS } from '../../Checkout/styleTag';
import { Grid, Col, Row } from '@vds3/grids';
import { TextLinkCaret } from '@vds/buttons';

export const Header = () => {
    return (
        <div>
            <Grid>
                <Row>
                     <Col colSizes={{desktop:12, tablet:12, mobile:4}}>
                    <Title size="large">Next Steps</Title>
                    <MarginSpacerM/>
                    </Col>
                </Row>
                <Row>
                    <Col colSizes={{desktop:4, tablet:4, mobile:4}}>
                    <NextSteps number="01" title="We'll send you a link to your order status." content="So you can track your order."/>
                    </Col>
                    <Col colSizes={{desktop:4, tablet:4, mobile:4}}>
                    <NextSteps number="02" title="Look out for an email from Verizon." content="If there are any issues, we’ll need to contact you. "/>
                    </Col>
                    <Col colSizes={{desktop:4, tablet:4, mobile:4}}>
                    <NextSteps number="03" title="Would you like to sign up for MyBusiness?" content="You can manage your account, pay your bill, shop and more."/>
                    <MarginSpacerM/>
                    <TextLinkCaret 
                    surface="light"  
                    iconPosition="right"
                    onClick={()=>window.open('https://mblogin.verizonwireless.com/account/business/login/unifiedlogin')}>
                    Sign Up
                    </TextLinkCaret>
 
                    </Col>
                </Row>
            </Grid>
        </div>
    );
};




const NextSteps = ({number,title,content}) => {
    return (
        <div style={{borderTop:'1px solid black'}}>
            <MarginSpacerM/>
            <Title size="small" bold>{number}</Title>
            <MarginSpacerS/>
            <Title size="large" bold>{title}</Title>
            <MarginSpacerS/>
            <Body size="large">{content}</Body>
        </div>
    );
};